import { render, staticRenderFns } from "./AdvertPrintList.vue?vue&type=template&id=634f7cf5&scoped=true&"
import script from "./AdvertPrintList.vue?vue&type=script&lang=js&"
export * from "./AdvertPrintList.vue?vue&type=script&lang=js&"
import style0 from "./AdvertPrintList.vue?vue&type=style&index=0&id=634f7cf5&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "634f7cf5",
  null
  
)

export default component.exports